import React, { useState } from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import WizardChildren from '../../WizardChildren';
import styles from './WizardCollapse.module.scss';
import Vstack from '../../../../BaseModule/Components/VStack/Vstack';
import { joinClasses } from '../../../../../Utils/className.util';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.COLLAPSE }>;
	onSubmit: (values: object) => void;
}

const WizardCollapse: React.FC<Props> = ({ item, onSubmit }) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className={styles.wrapper}>
			<div
				onClick={() => setIsOpen(prev => !prev)}
				className={joinClasses([styles.title, isOpen ? styles.isOpen : ''])}
			>
				{item.title}
			</div>
			{isOpen && (
				<Vstack>
					{item.children.map(child => (
						<WizardChildren item={child} onSubmit={onSubmit} />
					))}
				</Vstack>
			)}
		</div>
	);
};

export default WizardCollapse;
